import type { SVGProps } from "react";
const SenecPictogramHomeClimate = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M24.4577 4.79224L8 15.6166V32C8 32.5523 8.44772 33 9 33C9.55228 33 10 32.5523 10 32V16.695L24.4247 7.20775L38 16.6775V39H10V37C10 36.4477 9.55228 36 9 36C8.44772 36 8 36.4477 8 37V41H40V15.6341L24.4577 4.79224Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32 29.126V19.0002C32 18.448 31.5523 18.0002 31 18.0002C30.4477 18.0002 30 18.448 30 19.0002V29.126C28.2748 29.5701 27 31.1362 27 33C27 35.2091 28.7909 37 31 37C33.2091 37 35 35.2091 35 33C35 31.1362 33.7252 29.5701 32 29.126ZM31.0184 31.0001L31 31.0002L30.9816 31.0001C29.8855 31.01 29 31.9016 29 33C29 34.1046 29.8954 35 31 35C32.1046 35 33 34.1046 33 33C33 31.9016 32.1145 31.01 31.0184 31.0001Z"
            fill="currentColor"
        />
        <path
            d="M18 18.0002C18.5523 18.0002 19 18.448 19 19.0002V22.0002H22C22.5523 22.0002 23 22.448 23 23.0002C23 23.5525 22.5523 24.0002 22 24.0002H19V27.0002C19 27.5525 18.5523 28.0002 18 28.0002C17.4477 28.0002 17 27.5525 17 27.0002V24.0002H14C13.4477 24.0002 13 23.5525 13 23.0002C13 22.448 13.4477 22.0002 14 22.0002H17V19.0002C17 18.448 17.4477 18.0002 18 18.0002Z"
            fill="currentColor"
        />
        <path
            d="M22 36C22.5523 36 23 35.5523 23 35C23 34.4477 22.5523 34 22 34H14C13.4477 34 13 34.4477 13 35C13 35.5523 13.4477 36 14 36H22Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramHomeClimate;
